<div class=imminent class:masterView={user.isMaster} class:current={view.persona.ID === imminent.subject}>
	<div class=tick-time title={imminent.ID}>{timestamp(imminent.time)}</div>
	<figure class="icon tick-actor" onclick={() => view.select_persona(imminent.subject)}>
    <img src={game.personas.get(imminent.subject).tokenURL} alt="{imminent.subject}">
    <figcaption>{imminent.subject ?? ''}</figcaption>
	</figure>
	<!-- 1st line: relevant action and target -->
	<span onmouseenter={show_action} onmouseleave={unshow_action}>{action}</span>
	<span class=centered>{imminent.target?.str ?? imminent.target ?? ""}</span>
	{#if user.isMaster && imminent.ZUB === 'Inspect'}
    <div class="review">
      <button class="button miniButton" onclick={decide_review.bind(imminent, 'ACCEPT')}>
        <img src="/static/buttons/accept.png" alt="Ja" class="commentImg">
      </button>
      <button class="button miniButton" onclick={decide_review.bind(imminent, 'REJECT')}>
        <img src="/static/buttons/reject.png" alt="Nein" class="commentImg">
      </button>
    </div>
	{/if}
	<!-- 2nd line: evaluation (only for master) -->
	<div class="rolled tick-double" title="{imminent.evaluation}">{rolled}</div>
	<!-- 3rd line: results incl. effects inline -->
  {#if imminent.force > 0 && effects}
    <div class="effectsList">
      {#each effects as eff}
        <span class="effect {eff.kind}" title="{(eff.descript) ? eff.descript : `${eff.name} -> ${eff.paramStr}`}"
					 onmouseenter={show_effect.bind(eff)} onmouseleave={() => view.close_dialog()} >
					{eff.effect}
				</span>
      {/each}
    </div>
  {:else}
    <div class="effectsList">{imminent.result}</div>
  {/if}
	<!-- 4th++ lines: subordinated incidents -->
	{#if imminent.subords}
	  {#each subordinateds as infl}
      <div class="inferior effectsList" title={infl.ID}>
	      <span>{infl.target}: </span>
	      {#if infl.force > 0}
	        {#each subEffects[infl.ID] as eff}
						{#if typeof eff === 'object'}
	            <span class="effect {eff.kind}" title="{(eff.descript) ? eff.descript : `${eff.name} -> ${eff.paramStr}`}" >{eff.effect}</span>
						{:else}
							<span>{eff}</span>
						{/if}
	        {/each}
	      {:else}
		      <span>kein Erfolg</span>
	      {/if}
      </div>
	  {/each}
	{/if}
	{#if warning}
        <img class="sitWarning" src="/static/images/warning.png" style="opacity: {warning * 33}%" alt="!">
	{/if}
</div>


<script>
    import { user, game, view, send_request} from "../client.svelte.js"
    import {timestamp, token_URL} from "../core.js";
		import {show_actionCard, close_actionCard} from "../dialogs/OptionDialog.svelte";

    let { imminent } = $props();
    let subject = $derived(game.personas.get(imminent.subject) )
    let action = $derived((game.activities.has(imminent.sender)) ? game.activities.get(imminent.sender).action : "???")
    let target  = $derived(game.personas.get(imminent.target))
    let rolled = $derived((user.isMaster) ? imminent.rolled ?? "" : "")
    let warning = $derived((!user.isMaster && target?.affil === 'fellow') ? Math.round(imminent.force) : 0)
    let effects = $derived(
			imminent.effects
				?.map(effID => game.effects.get(effID) ?? effID)
				?.filter(eff => eff))
    let subordinateds = $derived(
			(imminent.subords) ?
				imminent.subords.map(inflID => game.infos.get(inflID)).filter(infl => !('MUTED' in infl.flags)) :
				[])
    let subEffects = $derived(
			Object.fromEntries(
				subordinateds
					.map(infl => [infl.ID, infl.effects?.map(effID => game.effects.get(effID) ?? infl.text)])))

    // $inspect(`IMMINENT - imminent`, imminent)


    function decide_review(decision) {
        console.log(`IMMINENT-review: Master ${decision}s activity #${imminent.sender}  (Inspect: ${imminent.ID})`)
        send_request('decide', {inquiryID: imminent.ID, decision: decision})
		}

		let timer

		function show_action(e) {
				e.stopPropagation()
				if (action)
					timer = setTimeout(() => show_actionCard(action, 'map'), 500);
		}

		function unshow_action(e) {
				e.stopPropagation()
				clearTimeout(timer)
				if (view.option)
						close_actionCard()
		}

		function show_effect(e) {
				if (!view.dialog) {
						const coord = {x: e.clientX + 12, y: e.clientY + 36}
						view.show_dialog('effect', {effect: this, coord: coord})
				}
		}
</script>


<style lang="sass">
	.imminent
		margin: 12px 6px
		display: grid
		grid-template-columns: 4ch 60px 3fr 1fr 0
		grid-gap: 5px
		row-gap: 0

	.imminent.masterView
		grid-template-columns: 4ch 60px auto 4ch 36px

	.imminent.current
		font-weight: bold

	.tick-time
		grid-column: 1

	.tick-actor
		display: inline-block
		position: relative
		grid-column: 2
		grid-row: span 3

	.tick-double
		grid-column: 3 / span 2

	.inferior
		grid-column: 3 / span 2

	.review
		grid-row: span 3

	.sitWarning
		position: relative
		height: 40px
		right: 20px
		bottom: 20px

	.miniButton img
		width: 71%

	.effectsList
		grid-column: 3 / span 2
		display: inline-flex
		gap: 8px

	.effect
		border: darkgrey 1px solid
		background-color: hsl(var(--hue) 50% 50%)
		font-size: unset

	.effect.hurt
		--hue: 0
	.effect.harm
		--hue: 28
	.effect.nerf
		--hue: 56
	.effect.heal
		--hue: 120
	.effect.save
		--hue: 180
	.effect.buff
		--hue: 240
	.effect.envm
		--hue: 270
	.effect.move
		--hue: 300
</style>